/* ============
 * Auth Store
 * ============
 */

import http from '@/plugins/http';
import { defineStore } from 'pinia';
import './pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    authenticated: false,
    fromAdminId: null,
    trustedEmail: false,
    userAgent: null,
    currentEmail: null,
  }),

  actions: {
    check() {
      this.authenticated = !!localStorage.getItem('id_token');
      if (this.authenticated) {
        http.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('id_token')}`;
      }
    },

    login(token) {
      localStorage.removeItem('hide_banner_evolve');
      this.authenticated = true;
      localStorage.setItem('id_token', token);
      http.defaults.headers.common.Authorization = `Bearer ${token}`;
    },

    admin(adminId) {
      this.fromAdminId = adminId;
    },

    logout() {
      this.authenticated = false;
      this.currentEmail = null;
      localStorage.removeItem('id_token');
      localStorage.removeItem('perms');
      localStorage.removeItem('temp-agency-mode');
      http.defaults.headers.common.Authorization = '';
      localStorage.removeItem('instead-of-customer');

      document.cookie = `alreadyAuth=true;domain=.studentpop.fr;expires=${new Date(new Date().setDate(new Date().getDate() - 30))};samesite=Lax;`;

      if (window.ineum) {
        window.ineum('terminateSession');
      }
    },

    trusted() {
      this.trustedEmail = true;
    },

    setUserAgent() {
      const userAgent = window.navigator.userAgent.toLowerCase();

      this.userAgent = {
        path: userAgent,
        standalone: window.navigator.standalone,
        safari: /safari/.test(userAgent),
        studentPop: /student/.test(userAgent),
        android: /linux/.test(userAgent),
        androidWebview: /wv/.test(userAgent),
        iosWebview: /webview/.test(userAgent),
        ios: /iphone|ipod|ipad/.test(userAgent),
      };

      if (this.userAgent.androidWebview || this.userAgent.iosWebview) {
        const { body } = document;
        body.classList.add('sp-in-app');
      }
    },

    setCurrentEmail(email) {
      this.currentEmail = email;
    },
  },
});

export default useAuthStore;
